import { ValuesOf } from '@/types/utils'

/* GTM Events for postbacks */
export const GTM_EVENTS = {
  WebBuyButtonClicked: 'Web Buy Button Clicked',
}

export type GtmEvents = ValuesOf<typeof GTM_EVENTS>

/* defined by segment */
export const ENTRY_CHANNELS = {
  HomeScreen: 'home_screen',
  AccountTab: 'account_tab',
  MarketTab: 'market_tab',
  MoreTab: 'more_tab',
  SettingsPage: 'settings_page',
  CategoriesPage: 'categories_page',
  FirstActionGuide: 'first_action_guide',
  TradeDrawer: 'trade_drawer',
  FiatDrawer: 'fiat_drawer',
  Search: 'search',
  ForYou: 'for_you',
  Favourites: 'favourites',
  TopGainers: 'top_gainers',
  TopLosers: 'top_losers',
  New: 'new',
  MostTraded: 'most_traded',
  BuyDrawer: 'buy_drawer',
  SellDrawer: 'sell_drawer',
}

export type SegmentEventKeys = keyof typeof SEGMENT_EVENTS
export const SEGMENT_EVENTS = {
  HomepageViewed: 'Web Homepage Viewed',
  FirstActionGuideAddPaymentMethodClicked:
    'Web First Action Guide Add Payment Method Button Clicked',
  FirstActionGuideAddCardButtonClicked: 'Web First Action Guide Add Card Button Clicked',
  FirstActionGuideSetUpFiatWalletClicked:
    'Web First Action Guide Set-Up Fiat Wallet Button Clicked',
  SetUpFiatWalletSuccess: 'Web Set-Up Fiat Wallet Success',
  FirstActionGuideBuyCryptoClicked: 'Web First Action Guide Buy Crypto Button Clicked',
  FirstActionGuideSuccessViewed: 'Web First Action Guide Purchase Success Banner Viewed',
  WebCryptoLogoClicked: 'Web Crypto.com Logo Clicked',
  WebHomeTabClicked: 'Web Home Tab Clicked',
  WebAccountsTabClicked: 'Web Account Tab Clicked',
  WebMarketTabClicked: 'Web Market Tab Clicked',
  WebMoreTabClicked: 'Web More Tab Clicked',
  WebTradeButtonClicked: 'Web Trade Button Clicked',
  WebBuyCryptoViewed: 'Web Buy Crypto Viewed',
  WebSellCryptoViewed: 'Web Sell Crypto Viewed',
  WebCryptoPurchaseCoinSelected: 'Web Crypto Purchase Coin Selected',
  PurchaseCoinSelectionClicked: 'Web Crypto Purchase Coin Selection Clicked',
  WebOrderTypeClicked: 'Web Order Type Clicked',
  PurchasePrefilledOrderAmountClicked: 'Web Crypto Pre-filled Sale Percentage Button Clicked',
  PurchaseOrderConfirmationViewed: 'Web Crypto Purchase Order Confirmation Viewed',
  TradeAddCreditDebitCardClicked: 'Web Trade Drawer Add Credit/Debit Card Button Clicked',
  PurchaseOrderConfirmationClicked: 'Web Crypto Purchase Order Confirmation Clicked',
  PurchaseOrderAbandoned: 'Web Crypto Purchase Order Abandoned',
  ExchangeCompletedViewed: 'Web Crypto Exchange Completed Viewed',
  TradeDrawerSetUpFiatWalletClicked: 'Web Trade Drawer Set-Up Fiat Wallet Button Clicked',
  WebSettingsMenuClicked: 'Web Settings Menu Clicked',
  WebSearchCoinsBarClicked: 'Web Search Coins Bar Clicked',
  WebSearchCoinsBarResultClicked: 'Web Search Coins Bar Result Clicked',
  WebCryptoPurchaseOrderInitiated: 'Web Crypto Purchase Order Initiated',
  CoinFavouritesClicked: 'Web Coin Favourites Clicked',
  WebCoinAddFavouritesClicked: 'Web Coin Add Favourites Clicked',
  WebCoinRemoveFavouritesClicked: 'Web Coin Remove Favourites Clicked',
  CoinTopGainersClicked: 'Web Coin Top Gainers Clicked',
  CoinTopLosersClicked: 'Web Coin Top Losers Clicked',
  CoinNewTokensClicked: 'Web Coin New Tokens Clicked',
  CoinMostTradedTokensClicked: 'Web Coin Most Traded Tokens Clicked',
  WebLogOutClicked: 'Web Log Out Clicked',
  WebCryptoSellOrderInitiated: 'Web Crypto Sell Order Initiated',
  SellOrderConfirmationViewed: 'Web Crypto Sell Order Confirmation Viewed',
  SellOrderConfirmationClicked: 'Web Crypto Sell Order Confirmation Clicked',
  WebSellCryptoSuccessViewed: 'Web Sell Crypto Success Viewed',
  WebCryptoSellOrderAbandoned: 'Web Crypto Sell Order Abandoned',
  TradePaymentMethodClicked: 'Web Trade Drawer Crypto Payment Method Clicked',
  WebSwapFromCryptoClicked: 'Web Swap From Crypto Clicked',
  WebAccountTabViewed: 'Web Account Tab Viewed',
  AccountSetUpWalletClicked: 'Web Account Tab Set Up Wallet Button Clicked',
  AccountDownloadAppClicked: 'Web Account Tab Download App Button Clicked',
  AccountBuyClicked: 'Web Account Tab Buy Button Clicked',
  AccountSellClicked: 'Web Account Tab Sell Button Clicked',
  CoinClicked: 'Web Coin Page Clicked',
  AccountShowAllClicked: 'Web Account Tab Show All Crypto Clicked',
  AccountTxHistoryClicked: 'Web Account Tab Crypto Transaction History Clicked',
  AccountDepositClicked: 'Web Account Tab Deposit Button Clicked',
  AccountCashAccountClicked: 'Web Account Tab Cash Account Clicked',
  MarketViewed: 'Web Market Tab Viewed',
  SeeAllCategoriesClicked: ' Web Market Tab See All Categories Clicked',
  CoinPageViewed: 'Web Coin Page Viewed',
  GraphTimeFrameClicked: 'Web Coin Page Graph Time Frame Clicked',
  CoinWithdraw: 'Web Coin Page Withdraw Clicked',
  CoinPageShowDetailsClicked: 'Web Coin Page Show Details Clicked',
  CoinPageMarketSentimentClicked: 'Web Coin Page Market Sentiment Clicked',
  CoinPageShowMoreCategoriesClicked: 'Web Coin Page Show More Categories Clicked',
  CoinPageTxHistoryClicked: 'Web Coin Page Transaction History Clicked',
  CategoryPageViewed: 'Web Category Page Viewed',
  MarketTabCategoriesSorted: 'Web Market Tab Categories Sorted',
  CategorySelected: 'Web Category Selected',
  CategoryCoinSelected: 'Web Category Coin Selected',
  CoinSorted: 'Web Coin Sorted',
  DepositClicked: 'Web Deposit Button Clicked',
  DepositViewed: 'Web Deposit Screen Viewed',
  DepositCryptoClicked: 'Web Deposit Crypto Clicked',
  DepositCryptoNetworkClicked: 'Web Deposit Crypto Network Clicked',
  DepositCryptoAbandoned: 'Web Deposit Crypto Abandoned',
  DepositFiatClicked: 'Web Deposit Fiat Clicked',
  MoreTabViewed: 'Web More Tab Viewed',
  MoreTabQRCodeClicked: 'Web More Tab QR Code Clicked',
  SettingsViewed: 'Web Settings Viewed',
  SettingsPaymentClicked: 'Web Settings Display and Payment Currency Clicked',
  HelpCenterClicked: 'Web Settings Help Center Clicked',
  ContactSupportClicked: 'Web Settings Contact Support Button Clicked',
  PrivacyPreferencesClicked: 'Web Settings Privacy Preferences Clicked',
  FiatWalletTnCViewed: 'Web New Fiat Wallet TnC Viewed',
  FiatWalletTnCAccepted: 'Web New Fiat Wallet TnC Accepted',
  DepositMethodViewed: 'Web Fiat Choose Deposit Method Viewed',
  DepositMethodInitiated: 'Web Fiat Choose Deposit Method Initiated',
  WithdrawalMethodViewed: 'Web Fiat Choose Withdrawal Method Viewed',
  WithdrawalMethodInitiated: 'Web Fiat Choose Withdrawal Method Initiated',
  DepositDetailsViewed: 'Web Fiat Deposit Details Viewed',
  FiatDepositEmailRequested: 'Web Fiat Deposit Bank Info Email Requested',
  WebFiatCashAccountViewed: 'Web Fiat Cash Account Viewed',
  WebFiatCashAccountSwitchSelected: 'Web Fiat Cash Account Switch Selected',
  WebFiatCashAccountPersonalDetailsSelected: 'Web Fiat Cash Account Personal Details Selected', // TODO: @perry - Feature is currently not implemented, add this segment event after it's implement
  WebFiatCashAccountTransactionHistoryItemSelected:
    'Web Fiat Cash Account Transaction History Item Selected', // TODO: @perry - Feature is currently not implemented, add this segment event after it's implement
  WebFiatDepositReferenceMatchInitiated: 'Web Fiat Deposit Reference Match Initiated',
  WebFiatDepositReferenceMatchSubmitted: 'Web Fiat Deposit Reference Match Submitted',
  WebFiatDepositVendorChoiceConfirmed: 'Web Fiat Deposit Vendor Choice Confirmed',
  WebFiatDepositVendorChoiceInitiated: 'Web Fiat Deposit Vendor Choice Initiated',
  WebFiatDepositVendorChoiceSelected: 'Web Fiat Deposit Vendor Choice Selected',
  WebSportsEventDetailsAddPositionClicked: 'Web Sports Event Details Add Position Clicked',
  WebSportsClosePositionConfirmClicked: 'Web Sports Close Position Confirm Clicked',
  WebSportsEventDetailsClosePositionClicked: 'Web Sports Event Details Close Position Clicked',
  WebDerivsKYCIntroViewed: 'Web Derivs KYC Intro Viewed',
  WebDerivsKYCIntroExitClicked: 'Web Derivs KYC Intro Exit Clicked',
  WebDerivsKYCTnCsExitClicked: 'Web Derivs KYC TnCs Exit Clicked',
  WebDerivsKYCQualifyingQuestionsExitClicked: 'Web Derivs KYC Qualifying Questions Exit Clicked',
  WebDerivsKYCQualifyingQuestionsConfirmClicked:
    'Web Derivs KYC Qualifying Questions Confirm Clicked',
  WebSportsEventDetailsViewHistoryClicked: 'Web Sports Event Details View History Clicked',
  WebSportsEntryBannerClicked: 'Web Sports Entry Banner Clicked',
  WebSportsTabClicked: 'Web Sports Navigation Tab Clicked',
  WebSportsLandingPageViewed: 'Web Sports Landing Page Viewed',
  WebSportsLandingOpenPositionClicked: 'Web Sports Landing Open Position Clicked',
  WebSportsLandingAddPositionClicked: 'Web Sports Landing Add Position Clicked',
  WebSportsLandingClosePositionClicked: 'Web Sports Landing Close Position Clicked',
  WebSportsLandingViewHistoryClicked: 'Web Sports Landing View History Clicked',
  WebSportsLandingEventClicked: 'Web Sports Landing Event Clicked',
  WebSportsLandingYesNoClicked: 'Web Sports Landing YesNo Clicked',
  WebSportsEventDetailsViewed: 'Web Sports Event Details Viewed',
  WebSportsEventDetailsPlaceOrderClicked: 'Web Sports Event Details Place Order Clicked',
  WebSportsBracketEntryPointClicked: 'Web Sports Bracket Entry Point Clicked',
  WebSportsBracketClicked: 'Web Sports Bracket Clicked',
  WebUngatedSportsPlaceOrderClicked: 'Web Ungated Sports Trade Drawer CTA Clicked',
  WebUngatedSportsNavigationSignUpClicked: 'Web Ungated Sports Navigation Sign Up Clicked',
  WebUngatedSportsNavigationLogInClicked: 'Web Ungated Sports Navigation Log In Clicked',
  WebWelcomeBonusClaimClicked: 'Web Welcome Bonus Claim Clicked',
  WebWelcomeBonusWidgetClicked: 'Web Welcome Bonus Widget Clicked',
}
export type SegmentEvents = ValuesOf<typeof SEGMENT_EVENTS>

/* defined by Braze */
export const BRAZE_EVENTS = {
  // TODO
}
